
import React, { useState } from 'react';
import { Dialog, useTheme, Stack, DialogContent, TextField, Box, Grid, Typography } from '@mui/material';
import CustomButton from '../../components/CustomButton';
import { tokens } from "../../theme";
import {
  Timeline,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  } from '@mui/lab';
import { useEffect } from 'react';
import { selectedItems } from '../../config/AppConfig';
import { useAtom } from "jotai";
import DebugLog from '../../utils/DebugLog';
import Pagination from '@mui/material/Pagination';
import { formatPrice, formatInputWithCommas } from '../../utils/PriceFormatter';

function SaveAndRemoveEarmarkDialog({ 
    open, 
    onClose, 
    onDialogButtonClick ,
    onDialogRemoveButtonClick , 
    data , 
    earmarkTimeline,
    totalNoOfPages,
    onPageChange,
}) {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);
  const [earmarkTimelineDetails, setearmarkTimelineDetails] = useState([]);
  let earmarkInitialValue = ''
  let reasonInitialValue = ''

  const [initialFormData, setInitialFormData] = useState({
    earmark: '',
    reason: '',
  });

  // pagination 
  const pageCount = totalNoOfPages ? totalNoOfPages : 1;
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (value) => {
    setCurrentPage(value);
    onPageChange(value-1); // Index starts from 0 for data array
};

   
  useEffect(() => {
    if(data) {
       //  earmarkInitialValue = data.earmark
       //  reasonInitialValue = data.reason
       //  setEarmark(data.earmark)
       //  setReason(data.reason) 
        const value = {
        earmark: data.earmark,
        reason: data.reason,
        }
        setFormData(value)
        setInitialFormData(value); // Set initial form data
    }
    
    if(earmarkTimeline) {
      setearmarkTimelineDetails(earmarkTimeline)
    }

    clearErrors();
   
   // setFormData(earmarks,reasons)
    setDialogOpen(open);
    
  }, [open, data, earmarkTimeline]);
  
  const [formData, setFormData] = useState({
    //dealer: '',
      earmark: '',
      reason: '',
  });
  const [errors, setErrors] = useState({});

  const [dialogOpen, setDialogOpen] = useState(open);
  const handleInputChange = (e) => {
    const {  name, value } = e.target;
    const sanitizedValue = value.replace(/,/g, '');
    setFormData({ ...formData, [name]: sanitizedValue });
    setErrors({ ...errors, [name]: '' });
  };


//   const handleSubmit = () => {
//     // Handle form submission
//     // Close the dialog
//     onClose();
//   };


const handleRemove = (e) => {
  e.preventDefault();
  const newErrors = {};

  if (!formData.reason.trim()) {
    newErrors.reason = 'Reason is required';
   }
   if (Object.keys(newErrors).length === 0) {
    // Form is valid, submit the data

        // Close the dialog
        onClose();
        onDialogRemoveButtonClick(selectedItem, formData.earmark,formData.reason);

    } else {
        // Form is not valid, update the errors state
        setErrors(newErrors);
    }

}

const handleSubmit = (e) => {
 
    e.preventDefault();

    // Check if formData is the same as initialFormData
    if (JSON.stringify(formData) === JSON.stringify(initialFormData)) {
        alert('Cannot submit the same data as before. Please make changes to the form.');
        return;
    }

    // Validation logic
    const newErrors = {};

    DebugLog("formData.earmark.trim() ======="+formData.earmark)
    DebugLog("formData.earmark.trim() ======="+formData.reason.trim())
    
    if (!formData.earmark) {
        newErrors.earmark = 'Earmark is required';
    } else {
        let formattedEarmark = formData.earmark.trim();
  
        if (formattedEarmark <= 0){
          newErrors.earmark = 'Earmark amount must be greater than 0.00';
        } else {
            const isValid = /^[\d,]+(\.\d{1,2})?$/.test(formattedEarmark.replace(/,/g, ''));
          if (!isValid) {
            newErrors.earmark = 'Earmark must be a number with up to 2 decimal places';
          }
        }
      }

    if (!formData.reason.trim()) {
        newErrors.reason = 'Reason is required';
       }
    if (Object.keys(newErrors).length === 0) {
       // Close the dialog
       onClose();
       onDialogButtonClick(selectedItem, formData.earmark, formData.reason);
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };

  const clearErrors = () => {
    setErrors({});
    };

  return (
      <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: "12px", background:"transparent", boxShadow:"none" } }}>
        
        <DialogContent sx={{ background:"white", borderRadius:"12px", overflow: "initial", marginBottom:"15px" }}>
            <Grid container direction={'column'}>
                <Grid container>
                      <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                      >
                          <Typography fontWeight={'600'} variant="h3" p={1}>
                              Set Earmark
                          </Typography>
                      </Grid>
                      <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                          item
                      >
                          <Typography
                              fontSize={'16px'}
                              fontWeight={'400'}
                              pb={4}
                          >
                              {selectedItem.name}
                          </Typography>
                      </Grid>
                </Grid>

                <form>
                      <Grid container direction={'column'}>
                          <Grid
                              container
                              xs={12}
                              alignItems={'center'}
                              spacing={3}
                              pb={2}
                          >
                              <Grid item xs={4}>
                                  <Typography
                                      color={colors.grey[100]}
                                      fontWeight={'500'}
                                      variant="h6"
                                      sx={{ textAlign: 'right' }}
                                  >
                                      Earmark
                                  </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                  <TextField
                                      margin="dense"
                                      label="Earmark"
                                      type="text"
                                      name="earmark"
                                      fullWidth
                                      //defaultValue={earmarks}
                                      value={formatInputWithCommas(formData.earmark)}
                                      // value={earmarks}
                                      onChange={handleInputChange}
                                      error={Boolean(errors.earmark)}
                                      helperText={errors.earmark}
                                  />
                              </Grid>
                          </Grid>

                          <Grid
                              container
                              xs={12}
                              alignItems={'center'}
                              spacing={3}
                              pb={2}
                          >
                              <Grid item xs={4}>
                                  <Typography
                                      color={colors.grey[100]}
                                      fontWeight={'500'}
                                      variant="h6"
                                      sx={{ textAlign: 'right' }}
                                  >
                                      Reason
                                  </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                  <TextField
                                      margin="dense"
                                      label="Reason"
                                      type="text"
                                      name="reason"
                                      fullWidth
                                      //defaultValue={reasons}
                                      value={formData.reason}
                                      //value={reasons}
                                      onChange={handleInputChange}
                                      error={Boolean(errors.reason)}
                                      helperText={errors.reason}
                                  />
                              </Grid>
                          </Grid>

                          <Stack
                              direction="row"
                              pt={2}
                              spacing={2}
                              justifyContent={'center'}
                          >
                              <CustomButton
                                  btnBG={colors.primary[900]}
                                  btnColor={colors.grey[100]}
                                  btnTxt={'Remove Earmark'}
                                  btnBorder={'1px solid' + colors.primary[800]}
                                  onClick={handleRemove}
                              ></CustomButton>

                              <CustomButton
                                  btnBG={colors.primary[100]}
                                  btnColor={colors.grey[900]}
                                  btnTxt={'Save Earmark '}
                                  btnBorder={'1px solid' + colors.primary[100]}
                                  onClick={handleSubmit}
                              ></CustomButton>
                          </Stack>
                      </Grid>
                </form>
            </Grid>
        </DialogContent>

          <DialogContent sx={{ background:"white", borderRadius:"12px" }}>
              <Grid container direction={'column'}>
                  

                  <Grid container xs={12}>
                    <Grid container justifyContent="space-between" alignItems="center" sx={{ marginTop: 1 }}>
                        <Typography 
                            fontSize={20}
                            fontWeight={700}
                            xs={6}>Timeline</Typography>
                        <Pagination
                            xs={6}
                            count={pageCount}
                            page={currentPage}
                            onChange={(event, value) => handlePageChange(value)}
                        />
                    </Grid>

                              <Grid
                                  item
                                  xs={12}
                                  justifyitem={'flex-start'}
                                  alignitem={'flex-start'}
                              >
                                  {earmarkTimelineDetails.length > 0 ? (
                                      <Timeline
                                          sx={{
                                              [`& .${timelineItemClasses.root}:before`]:
                                                  {
                                                      flex: 0,
                                                      padding: 0,
                                                  },
                                          }}
                                      >
                                          {earmarkTimelineDetails.map((row, index) => (
                                              <TimelineItem key={row.id}>
                                                  <TimelineSeparator>
                                                      <TimelineDot
                                                          sx={{
                                                              background: (currentPage===1 && index === 0) ? colors.primary[100] : colors.primary[700],
                                                              width: '14px',
                                                              height: '14px',
                                                              marginTop: '70%',
                                                          }}
                                                      />
                                                      {index !== earmarkTimelineDetails.length - 1 && (
                                                      <TimelineConnector
                                                          sx={{
                                                              background: colors.primary[700],
                                                              width: '1px',
                                                          }}
                                                      />
                                                      )}
                                                  </TimelineSeparator>

                                                  <TimelineContent>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column'}}>
                                                    <Box sx={{ display: 'flex', flexWrap: 'nowrap' }}>
                                                        <Typography fontWeight={'600'} marginRight={'8px'}>
                                                        RM {formatPrice(row.earmark)}
                                                        </Typography>
                                                        <Typography fontWeight={'400'}>
                                                        {row.status}
                                                        </Typography>
                                                    </Box>
                                                    <Typography color={colors.grey[300]} fontSize={'0.8rem'}>
                                                        {row.date}
                                                    </Typography>
                                                    </Box>
                                                 </TimelineContent>
                                              </TimelineItem>
                                          ))}
                                      </Timeline>
                                  ) : (
                                      ''
                                  )}
                              </Grid>

                              {/* <Grid item fontSize={20} fontWeight={700} xs={6}>Date Time</Grid> */}

                              <Grid item></Grid>
                          </Grid>
              </Grid>
          </DialogContent>
          {/* <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button  variant="contained" type="submit" onClick={handleSubmit} color="primary">
          Submit
        </Button>
      </DialogActions> */}
      </Dialog>
  );
}

export default SaveAndRemoveEarmarkDialog;
